/*** IMPORTS FROM imports-loader ***/
var define = false;

export { default } from "../get/_index.mjs"
